import React from "react";
import { ErrorDetails } from "../../Common/Types";
import { Loading } from "@ilc-technology/luik";
import { ContentError } from "./ContentError";
import { useDatasources } from "../../contexts/StoryblokContext/StoryblokContext";

interface ErrorComponentWrapperProps {
  isLoading: boolean;
  children?: React.ReactNode;
  error?: ErrorDetails;
  errorFooter?: React.ReactNode;
}

const ErrorComponentWrapper: React.FC<ErrorComponentWrapperProps> = ({ isLoading, error, children, errorFooter }) => {
  const { labels } = useDatasources();

  if (isLoading && !error) {
    return (
      <div className="m-auto flex justify-center overflow-hidden">
        <Loading className="loading overflow-hidden rounded-full" size="lg" intent="black" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="m-auto">
        <ContentError errorDetails={error} labels={labels} bottomChildren={errorFooter} />
      </div>
    );
  }

  // Render children if there is no error and content loaded
  return !isLoading && !error && <>{children}</>;
};

export default ErrorComponentWrapper;
